/* eslint-disable */
import React, { Component } from 'react'
// import PropTypes from 'prop-types';
import { View, Text, TouchableHighlight, Image, TouchableOpacity, TouchableWithoutFeedback } from 'react-native'
import styles from './Styles/AvatarComponentStyle'
import { Avatar } from 'react-native-elements'
//import FastImage from 'react-native-fast-image'
//import FastImage from '../Components/FastImage'
import UserActions from "../Redux/UserRedux"
import { connect } from 'react-redux'
import { KargoeConfig } from '../Config/AppConfig'

/*export default*/ class AvatarComponent extends Component {
  constructor(props) {
    super(props)
    this.state = {
       refreshAvatar: 0 // not used
    }
    const { size = 60, style, userId, onPress, onLongPress } = this.props
    this.touchStyle = {width: size, height: size , borderRadius: size / 2}
    this.imageStyle = [styles.container, {width: size, height: size , borderRadius: size / 2}, style ]
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { size = 60, userId } = this.props
    if (this.props.size != nextProps.size)
      return true
    if (this.props.userId != nextProps.userId)
      return true
    return false
  }

  render() {
    const { size = 60, style, userId, onPress, onLongPress } = this.props
    // if cache is false, force a clear of fast image cache for that 1 image
    // if cache is not specified, default to true
    // FastImage refreshAvatar={this.props.refreshAvatar} // not used by fast image 
    // `https://s3.amazonaws.com/kargoe2-dev/${userId}-avatar.jpg`
    let cache = true
    if (Object.keys(this.props).indexOf('cache') > -1)
      cache = this.props.cache 
		const theUri = `${KargoeConfig.baseUrlMedia}/${userId}-avatar.jpg` + (cache ? '' : '?clearFastImageCache')
    this.fastImageSource = {
      uri: theUri,
      cache : 'reload'
    }
    return (
      <TouchableWithoutFeedback
       key={`av-touch-${userId}`}
       style={this.touchStyle}
			 onPress={onPress}
			 onLongPress={onLongPress}
			>
      <Image
        key={`av-img-${userId}`}
        style={this.imageStyle}
        source={this.fastImageSource}
        resizeMode={'contain'}
      />
      </TouchableWithoutFeedback>
    )
  }
}

// if any place in the app mods the refreshAvatar property of user redux, this component will render
const mapStateToProps = state => {
    return {
      refreshAvatar: state.user.refreshAvatar
    }
}

const mapDispatchToProps = dispatch => ({
})

export default connect(mapStateToProps, mapDispatchToProps)(AvatarComponent)
